import { FormEditor } from './form-editor.base.model';

export class Parameters extends FormEditor<Array<any>> {
  controlType = 'parameters';

  constructor(options: {} = {}) {
    super(options);
    this.entities = options['entities'] || [];
  }
}
